var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRedFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C5.46957 3 4.96086 3.21071 4.58579 3.58579C4.21071 3.96086 4 4.46957 4 5V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22C5.26522 22 5.51957 21.8946 5.70711 21.7071C5.89464 21.5196 6 21.2652 6 21V16H19.804C20.0069 16.0001 20.206 15.944 20.379 15.838C20.5521 15.732 20.6924 15.5802 20.7845 15.3993C20.8767 15.2185 20.917 15.0157 20.901 14.8134C20.885 14.6111 20.8134 14.4171 20.694 14.253L17.236 9.5L20.692 4.747C20.8113 4.58294 20.8829 4.38908 20.899 4.18686C20.915 3.98463 20.8748 3.78192 20.7828 3.60112C20.6908 3.42032 20.5506 3.26849 20.3776 3.1624C20.2047 3.05632 20.0059 3.00011 19.803 3H6Z",
    fill: "#D81E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRedFlag);
export default __webpack_public_path__ + "static/media/Ic_Red_Flag.27ba5d8f01b20d2eb007e489cb65b3a5.svg";
export { ForwardRef as ReactComponent };